import { Alert, AlertTitle } from "@mui/material";
import { carbonCropsEndpoints } from "portal/state/portal/carbonCrops";
import { classes } from "common/theme/theme";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { VeselkaCropLabel } from "./VeselkaCropLabel";
import React, { FC } from "react";

interface UnassociatedVeselkaCropsWarningProps {
  className?: string;
}
export const UnassociatedVeselkaCropsWarning: FC<
  UnassociatedVeselkaCropsWarningProps
> = ({ className }) => {
  const { t } = useTranslation();

  const { data: unassociatedVeselkaCrops } = useQueryPopups(
    carbonCropsEndpoints.listUnassociatedVeselkaCrops.useQuery({})
  );

  const unassociatedCrops = unassociatedVeselkaCrops?.crops ?? [];
  const summaryCount = 5;
  return unassociatedCrops.length > 0 ? (
    <Alert severity="warning" className={classes("shrink-0", className)}>
      <AlertTitle>
        {t("components.carbonCrop.unassociatedAlert.title")}
      </AlertTitle>
      {t("components.carbonCrop.unassociatedAlert.body", {
        count: unassociatedCrops.length,
      })}
      <ul className="list-disc pl-5 mt-2 mb-0">
        {unassociatedCrops.slice(0, summaryCount).map((crop, i) => (
          <li key={crop.id}>
            <VeselkaCropLabel crop={crop} />
            {i === summaryCount - 1 &&
            unassociatedCrops.length > summaryCount ? (
              <span className="ml-2">...</span>
            ) : undefined}
          </li>
        ))}
      </ul>
    </Alert>
  ) : undefined;
};
